import React, {useState} from "react";
import RaikoBaseContainer from "../../raikoComponents/raikoBaseContainer/RaikoBaseContainer";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import {css} from "@emotion/css";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import {RouteInfo} from "../../route/RouteHelper";
import ButtonSecondaryRaiko from "../../raikoComponents/raikoButtons/ButtonSecondaryRaiko";
import {useNavigate, useParams} from "react-router-dom";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import NewsDetailBaseInfo from "./NewsDetailBaseInfo";
import NewsDetailThumbnail from "./NewsDetailThumbnail";
import NewsDetailSeoInfo from "./NewsDetailSeoInfo";
import SeoComponent from "../../component/seo/SeoComponent";
import {NewsService} from "../../serverService/newsService/NewsService";

export default function NewsDetail() {

    const navigate = useNavigate()

    const {id} = useParams()

    const [tabSelectedValue, setTabSelectedValue] = useState(newsTabTypes.newsDetail.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <ButtonDivisionSection>
                    <RaikoBreadcrumb
                        className={css`flex-grow: 1`}
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                "اخبار",
                                RouteInfo.NewsList.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                "جزئیات خبر",
                                ""
                            ),
                        ]}/>

                    <ButtonSecondaryRaiko
                        label={"بازگشت"}
                        onClick={_ => {
                            navigate(RouteInfo.NewsList.globalUrl)
                        }}/>
                </ButtonDivisionSection>

                <TabContext value={tabSelectedValue}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}} className={css`
                      border-color: var(--header-border-bottom-color) !important;
                    `}>
                        <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                            <Tab icon={<div id="tabIcon" className={"ic-location"}/>} iconPosition="start"
                                 label={newsTabTypes.newsDetail.title}
                                 value={newsTabTypes.newsDetail.id}/>
                            <Tab icon={<div id="tabIcon" className={"ic-location"}/>} iconPosition="start"
                                 label={newsTabTypes.thumbnail.title}
                                 value={newsTabTypes.thumbnail.id}/>
                            <Tab icon={<div id="tabIcon" className={"ic-location"}/>} iconPosition="start"
                                 label={newsTabTypes.seoDetail.title}
                                 value={newsTabTypes.seoDetail.id}/>
                        </TabList>
                    </Box>
                    <TabPanel value={newsTabTypes.newsDetail.id}>
                        <NewsDetailBaseInfo newsId={id}/>
                    </TabPanel>

                    <TabPanel value={newsTabTypes.thumbnail.id}>
                        <NewsDetailThumbnail newsId={id}/>
                    </TabPanel>

                    <TabPanel value={newsTabTypes.seoDetail.id}>
                        <SeoComponent id={id} serviceInstance={new NewsService()}/>
                    </TabPanel>
                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}


const newsTabTypes = {
    newsDetail: {
        id: "news-detail",
        title: "اطلاعات پایه"
    }, thumbnail: {
        id: "news-thumbnail",
        title: "تصویر شاخص"
    }, seoDetail: {
        id: "seo-detail",
        title: "بهینه سازی موتور جستجو"
    },
}